export const blockIconsMapsDeliveryDining = (
	<span className='material-symbols-outlined'>delivery_dining</span>
);
